import { Card, CardContent } from '../ui/card';
import { Users, Mail, FileText } from 'lucide-react';

const STAT_CONFIGS = [
  { key: 'total_contacts', label: 'Total Contacts', icon: Users, bgColor: 'bg-blue-100', iconColor: 'text-blue-600', valueColor: 'text-slate-900' },
  { key: 'new_contacts', label: 'New Contacts', icon: Mail, bgColor: 'bg-green-100', iconColor: 'text-green-600', valueColor: 'text-green-600' },
  { key: 'total_quotes', label: 'Total Quotes', icon: FileText, bgColor: 'bg-purple-100', iconColor: 'text-purple-600', valueColor: 'text-slate-900' },
  { key: 'new_quotes', label: 'New Quotes', icon: FileText, bgColor: 'bg-orange-100', iconColor: 'text-orange-600', valueColor: 'text-orange-600' },
];

export function AdminStatsGrid({ stats }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      {STAT_CONFIGS.map((cfg) => (
        <Card key={cfg.key} data-testid={`stat-${cfg.key.replace('_', '-')}`}>
          <CardContent className="p-6">
            <div className="flex items-center gap-4">
              <div className={`w-12 h-12 ${cfg.bgColor} rounded-lg flex items-center justify-center`}>
                <cfg.icon className={`w-6 h-6 ${cfg.iconColor}`} />
              </div>
              <div>
                <p className="text-sm text-slate-600">{cfg.label}</p>
                <p className={`text-2xl font-bold ${cfg.valueColor}`}>{stats[cfg.key]}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
